// extracted by mini-css-extract-plugin
module.exports = {"newButton":"NewComponents_newButton__1wL5a"};